<script>
	export default {
		props: {
			filterName: String,
			options: {
				type: Array,
				default() {
					return []
				}
			}
		},
		data() {
			return {
				selected: null
			}
		},
		mounted() {
			this.initSelect2()
		},		
		methods: {
			onSelect(value) {
				this.$set(this, 'selected', value)
			},
			initSelect2() {
				let vm = this
				if (!this.$refs.sport) {
					return
				}

	            $(this.$refs.sport).select2({
	                ajax: {
	                    url: route('api.sports'),
	                    delay: 500,
	                    data: function (params) {
	                        return {
	                        	q: params.term
	                        }
	                    },
	                    processResults: function (data) {
	                        var results = [];

	                        data.sports.forEach(function (a, b) {
	                            results.push({
	                                'id': a.id,
	                                'text': a.name
	                            })
	                        })

	                        return {
	                            results: results
	                        };
	                    }
	                }            	
	            });

	            $(this.$refs.sport).on('change', function (event) {
	            	let selected = $(this).select2('data')[0];

                    if (_.isObject(selected)) {
                    	vm.onSelect(selected)
                    }
	            })	            
			},	
			onApply() {
            	this.$emit('update-filters', {
            		key: this.filterName,
            		value: this.selected
            	})
			},
			onReset() {
				this.$set(this, 'selected', null)

            	this.$emit('update-filters', {
            		key: this.filterName,
            		value: this.selected
            	})
			}	
		}
	}
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/checkin/CheckinFilterModal.vue